module.exports = __webpack_public_path__ + "img/page26.6378d69e.jpg";